// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"d8f81a14","845":"9ccfd358"}[chunkId] + ".chunk.js";
};